<div *ngIf="isLoading" class="overlay"></div>
<div *ngIf="isLoading" class="loader width--200px padding--16px border-radius--100"></div>